import 'react-datepicker/dist/react-datepicker.css';
import './AppDateTimeInput.scss';

import DatePicker from 'react-datepicker';
import React from 'react';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale } from 'react-datepicker';

registerLocale('pt-BR', ptBR);

function AppDateTimeInput({ 
    label, 
    value, 
    onChange, 
    name, 
    isRequired, 
    errors, 
    touched,
    minDate,
    maxDate,
    placeholder = 'DD/MM/YYYY HH:MM'
}) {
    // Converte string ISO para Date object
    const dateValue = value ? new Date(value) : null;

    const handleChange = (date) => {
        if (date) {
            // Converte Date para string ISO (formato esperado pelo backend)
            const isoString = date.toISOString();
            onChange({ target: { name, value: isoString } });
        } else {
            onChange({ target: { name, value: '' } });
        }
    };

    const hasError = errors && errors[name] && touched && touched[name];

    return (
        <div className="app-datetime-input">
            <label className="field-label">
                {label} {isRequired && <span className="required">*</span>}
            </label>
            <DatePicker
                selected={dateValue}
                onChange={handleChange}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="dd/MM/yyyy HH:mm"
                locale="pt-BR"
                placeholderText={placeholder}
                minDate={minDate}
                maxDate={maxDate}    
                className={`form-control piker ${hasError ? 'is-invalid' : ''}`}
                autoComplete="off"
            />
            {hasError && (
                <div className="invalid-feedback d-block">
                    {errors[name]}
                </div>
            )}
        </div>
    );
}

export default AppDateTimeInput;